import React from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import Loader from 'relements/build/esm/decorators/loader';
import Notification from 'relements/build/esm/overlays/notification';

import hashHistory from '@src/History';

// Components
import App from '@src/containers/App';
import BusinessManagerSwitch from '@src/containers/BusinessManagerSwitch';
import WebGuideSwitch from '@src/containers/WebGuideSwitch';
import AIAgents from '@src/containers/AIAgents';
import AIAgent from '@src/containers/AIAgents/AIAgent';
import EditorContainer from '@src/containers/AIAgents/components/EditorContainer';
import Home from '@src/containers/Home';
import BotStore from '@src/store';
import Redirector from '@src/containers/Redirector';
import SubStories from 'containers/SubStories';
import Skillsets from '@src/containers/Skillsets';
import GeneralResponses from '@src/containers/Overlays/GeneralResponses';
import StepPriorities from '@src/containers/Overlays/StepPriorities';
import GeneralNodes from '@src/containers/Overlays/GeneralNodes';
import SmallTalk from '@src/containers/SmallTalk';
import AgentEscalation from '@src/containers/AgentEscalation';
import VoicePage from '@src/containers/VoicePage';

// Constants
import * as ROUTES from 'constants/Routes';

// Actions
import { locationChanged } from '@src/actions/BotActions';
import { setURLMetadata } from '@src/actions/SubstoryActions';

@Loader({})
export default class AppRoot extends React.Component {
  constructor(props) {
    super(props);
    hashHistory.listen((location) => {
      this.initURLMetadata(location.pathname);
      locationChanged(location);

      // Destroy on-going notifications if user navigates away from graph page
      if (!location.pathname.includes('/substories')) {
        Notification.destroyAll();
      }
    });
  }

  initURLMetadata = (path) => {
    this.props.activateLoader();
    setURLMetadata(path, () => {
      this.props.deactivateLoader();
    });
  };

  componentDidMount() {
    this.initURLMetadata(window.location.hash.slice(1));
  }

  render() {
    return (
      <div>
        <Router history={hashHistory}>
          <App>
            <Switch>
              {!BotStore.getSelfServeLayout() && (
                <Route exact path="/bot/:botId" component={Skillsets} />
              )}

              <Route
                exact
                path="/bot/:botId/general-responses"
                component={GeneralResponses}
              />
              <Route
                exact
                path="/bot/:botId/step-priorities"
                component={StepPriorities}
              />
              <Route
                exact
                path="/bot/:botId/general-nodes"
                component={GeneralNodes}
              />
              <Route
                exact
                path="/bot/:botId/:storyId/general-nodes"
                component={GeneralNodes}
              />
              <Route
                exact
                path="/business-manager/:businessIdentifier"
                component={BusinessManagerSwitch}
              />
              <Route
                exact
                path="/webguide/:botId/:businessIdentifier"
                component={WebGuideSwitch}
              />
              <Route
                exact
                path="/ai-agents-project/:botId"
                component={AIAgents}
              />
              <Route
                exact
                path="/ai-agents-project/:botId/agent/:agentId"
                component={AIAgent}
              />
              <Route
                exact
                path="/ai-agents-project/:botId/agent/:agentId/action/:actionId/editor"
                component={EditorContainer}
              />
              <Route
                exact
                path={ROUTES.AGENT_ESCALATION}
                component={AgentEscalation}
              />
              <Route
                exact
                path={ROUTES.EDIT_TOOL}
                component={AgentEscalation}
              />
              <Route
                path={ROUTES.EDIT_TOOL_PARAMS}
                component={AgentEscalation}
              />
              <Route
                exact
                path="/search/nodes/:nodeName"
                component={Redirector}
              />
              <Route exact path={ROUTES.SMALLTALK} component={SmallTalk} />
              <Route path={`${ROUTES.CONNECTION}`} component={SubStories} />
              <Route path={`${ROUTES.SUBSTORIES}`} component={SubStories} />
              <Route
                exact
                path="/ai_agents/in-browser-calling/:botId"
                component={VoicePage}
              />
              <Route
                exact
                path="/ai_agents/in-browser-calling/:botId/demo"
                component={VoicePage}
              />
              <Route path="/" component={Home} />
            </Switch>
          </App>
        </Router>
      </div>
    );
  }
}
